import type {
  UpdateInvoiceIssueDateRequestPayload,
  UpdateInvoiceIssueDateResponse,
} from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidateInvoicesQueries } from '../../utils/query-invalidation';

interface UpdateInvoiceIssueDatePayload {
  invoiceId: string;
  updateInvoiceIssueDateRequest: UpdateInvoiceIssueDateRequestPayload;
}

export function useUpdateInvoiceIssueDate(
  options?: UseMutationOptions<UpdateInvoiceIssueDateResponse, unknown, UpdateInvoiceIssueDatePayload>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ invoiceId, updateInvoiceIssueDateRequest }) => {
      const api = getPrivateApi();

      return api.updateInvoiceIssueDate({ invoiceId, updateInvoiceIssueDateRequest });
    },
    onSuccess: async () => {
      await invalidateInvoicesQueries(queryClient);
    },
    ...options,
  });
}
